import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sidebar = _resolveComponent("sidebar")!
  const _component_navbar = _resolveComponent("navbar")!
  const _component_tags_view = _resolveComponent("tags-view")!
  const _component_app_main = _resolveComponent("app-main")!
  const _component_settings = _resolveComponent("settings")!
  const _component_right_panel = _resolveComponent("right-panel")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.classObj, "app-wrapper"]),
    style: _normalizeStyle({'--current-color': _ctx.theme})
  }, [
    (_ctx.device==='mobile'&&_ctx.sidebar.opened)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "drawer-bg",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClickOutside && _ctx.handleClickOutside(...args)))
        }))
      : _createCommentVNode("", true),
    (!_ctx.sidebar.hide)
      ? (_openBlock(), _createBlock(_component_sidebar, {
          key: 1,
          class: "sidebar-container"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass([{hasTagsView:_ctx.needTagsView,sidebarHide:_ctx.sidebar.hide}, "main-container"])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass({'fixed-header':_ctx.fixedHeader})
      }, [
        _createVNode(_component_navbar),
        (_ctx.needTagsView)
          ? (_openBlock(), _createBlock(_component_tags_view, { key: 0 }))
          : _createCommentVNode("", true)
      ], 2),
      _createVNode(_component_app_main),
      _createVNode(_component_right_panel, null, {
        default: _withCtx(() => [
          _createVNode(_component_settings)
        ]),
        _: 1
      })
    ], 2)
  ], 6))
}